import { PlusIcon } from '@/design-system/icons'

interface Props {
  onClick: () => void
  label?: string
}

/**
 * Floating action button. Anchored fixed to viewport bottom-right, ABOVE
 * the TabBar (which is fixed at bottom-0). Position math:
 *   TabBar height ≈ 64px + safe-area-inset-bottom
 *   FAB sits at 88px + safe-area so there's a 24px gap above the tab row.
 */
export function FAB({ onClick, label = 'Quick log' }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="fixed right-4 z-40 h-14 w-14 rounded-full flex items-center justify-center active:scale-95 transition-transform"
      style={{
        bottom: 'calc(88px + env(safe-area-inset-bottom))',
        background: 'linear-gradient(180deg, #FF8942 0%, #FF7A2D 55%, #F26A1F 100%)',
        color: 'white',
        boxShadow:
          'inset 0 1px 0 rgba(255,255,255,0.25), 0 10px 28px -8px rgba(255,122,45,0.55), 0 4px 10px rgba(255,122,45,0.20)',
      }}
    >
      <PlusIcon size={26} />
    </button>
  )
}
